import React from "react";
import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { motion } from "framer-motion"
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation, Keyboard } from 'swiper/modules';
import { Parallax, useParallax } from 'react-scroll-parallax';
import '../assets/css/team-slider.css';
import '../assets/css/services-slider.css';
import { Link } from "react-router-dom";

const Home = () => {

  const [selectedIndustry, setSelectedIndustry] = useState("All");
  const [selectedService, setSelectedService] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const blogPosts = [
    {
      id: 1,
      title: "How to Create an Intranet Site Using SharePoint for Your Business",
      image: "https://www.q3tech.com/wp-content/uploads/2025/11/Intranet-Site-Using-SharePoint.jpg",
      date: "Dec 15, 2024",
      industry: "All",
      service: "Web Development",
      excerpt: "Learn how to leverage SharePoint to build a powerful intranet solution that enhances collaboration and productivity in your organization."
    },
    {
      id: 2,
      title: "AI Agent Use Cases: Real-World Applications Revolutionizing Business Operations",
      image: "https://www.q3tech.com/wp-content/uploads/2025/11/AI-Agent-Use-Cases.jpg", date: "Dec 10, 2024",
      industry: "All",
      service: "AI & ML",
      excerpt: "Discover how AI agents are transforming business operations across industries with real-world applications and use cases."
    },
    {
      id: 3,
      title: "SharePoint Corporate Intranet Portal Features for Modern Enterprises",
      image: "https://www.q3tech.com/wp-content/uploads/2025/11/SharePoint-Corporate-Intranet-Portal.jpg",
      date: "Dec 5, 2024",
      industry: "Finance",
      service: "Cloud Services",
      excerpt: "Explore the essential features of SharePoint corporate intranet portals that drive digital transformation in modern enterprises."
    },

  ];

  const filteredBlogs = blogPosts.filter(blog => {
    const matchesIndustry = selectedIndustry === "All" || blog.industry === selectedIndustry;
    const matchesService = selectedService === "All" || blog.service === selectedService;
    const matchesSearch = blog.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      blog.excerpt.toLowerCase().includes(searchQuery.toLowerCase());

    return matchesIndustry && matchesService && matchesSearch;
  });

  const sliderImages = [
    {
      id: 1,
      url: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&q=80",
      title: "Building trust",
      subtitle: " Delivering excellence",
      description: "Delivering excellence through collaboration and innovation"
    },
    {
      id: 2,
      url: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1200&q=80",
      title: "Collaborative Teams",
      subtitle: " Driving Success",
      description: "Expert developers working together to deliver excellence"
    },
    {
      id: 3,
      url: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&q=80",
      title: "Strategic Planning",
      subtitle: "Agile Methodologies",
      description: "Agile methodologies driving project success"
    },
    {
      id: 4,
      url: "https://images.unsplash.com/photo-1531498860502-7c67cf02f657?w=1200&q=80",
      title: "Technical Excellence",
      subtitle: "Innovative Solutions",
      description: "Cutting-edge technology solutions for modern businesses"
    }
  ];
  const [active, setActive] = useState("marketing");


  return (
    <>

      {/* Hero Slider Section */}
      <section className="hero-slider-section">
        <Swiper
          modules={[Pagination, Autoplay, Keyboard]}
          spaceBetween={0}
          slidesPerView={1}
          pagination={{
            clickable: true,
            dynamicBullets: false
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          keyboard={{
            enabled: true
          }}
          speed={1000}
          loop={true}
          className="hero-main-slider"
        >
          {sliderImages.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div className="hero-slide-container">
                <img
                  src={slide.url}
                  alt={slide.title}
                  className="hero-slide-image"
                />
                <div className="hero-slide-overlay">
                  <div className="container container--narrow">
                    <div className="hero-slide-content">
                      <div className="row">
                        <div className="col-md-12 col-xxl-12">
                          <span className="hero-label">OUR PURPOSE</span>
                          <h1 className="hero-main-heading">
                            {slide.title}<br />
                            {slide.subtitle}
                          </h1>
                          <p className="hero-description" style={{ textAlign: 'center', color: '#ffffff' }}>
                            {slide.description}
                          </p>

                          <Link to="/contact" style={{ textDecoration: 'none' }}>
                            <button className="breadcrumb-btn">
                              <span>CONNECT NOW</span>
                              <span className="breadcrumb-arrow">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </span>
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* Introduction About AI ProPixel Section */}
      <section className="intro-about-section py-5">
        <div className="container">
          <div className="row align-items-center g-5">
            {/* Left Content */}
            <div className="col-lg-6">
              <div className="intro-about-images-grid">
                <div className="row g-3">
                  <div className="col-6">
                    <div className="intro-image-wrapper main-image">
                      <img
                        src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80"
                        alt="Professional Team Member"
                        className="intro-image"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="intro-image-wrapper secondary-image">
                      <img
                        src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80"
                        alt="Team Collaboration"
                        className="intro-image"
                      />
                      <div className="experience-badge">
                        <div className="experience-content">
                          <h3 className="experience-number">8+</h3>
                          <p className="experience-text">YEARS OF<br />EXPERIENCE</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-6">
              <div className="intro-about-content">
                <h2 className="intro-about-heading">
                  About <span className="text-gradient">Profit Technologies</span>
                </h2>
                <p className="intro-about-description">
                  Profit Technologies is a professional IT services company delivering smart, scalable, and reliable digital solutions. We help businesses strengthen their online presence and improve performance through technology-driven services. Our focus is on quality, innovation, and results that support long-term business growth.
                </p>

                <Link to="/about" style={{ textDecoration: 'none' }}>
                  <button className="breadcrumb-btn button-about">
                    <span>LEARN MORE</span>
                    <span className="breadcrumb-arrow">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Slider Section */}
      <section className="services-slider-section py-5">
        <div className="container">
          <div className="text-center mb-5">
            <span className="services-label">OUR EXPERTISE</span>
            <h2 className="services-main-heading">
              Services Designed to Drive <span className="text-gradient">Growth</span>
            </h2>
            <p className="services-subtitle">
              Discover our full suite of capabilities that accelerate your digital transformation journey
            </p>
          </div>

          <Swiper
            modules={[Pagination, Autoplay, Navigation]}
            spaceBetween={30}
            slidesPerView={1}
            navigation={true}
            pagination={{
              clickable: true,
              dynamicBullets: true
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            speed={800}
            loop={true}
            breakpoints={{
              768: {
                slidesPerView: 2,
                spaceBetween: 25
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30
              }
            }}
            className="services-custom-swiper"
          >
            {/* Service 1 - App Development */}
            <SwiperSlide>
              <Link to="/services/app-development" style={{ textDecoration: 'none' }}>
                <div className="service-slider-card">
                  <div className="service-card-image">
                    <img
                      src="https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&q=80"
                      alt="App Development"
                    />
                    <div className="service-card-overlay"></div>
                  </div>
                  <div className="service-card-content">
                    <div className="service-icon-wrapper">
                      <img src={require('../assets/images/services/app.png')} alt="icon" />
                    </div>
                    <h3 className="service-card-title">App Development</h3>
                    <p className="service-card-subtitle">Transform Ideas Into Powerful Apps</p>
                    <p className="service-card-description">
                      Bring your vision to life with innovative mobile solutions that engage users and drive business growth. From concept to launch, we craft apps that make an impact.
                    </p>
                  </div>
                </div>
              </Link>
            </SwiperSlide>

            {/* Service 2 - Website Development */}
            <SwiperSlide>
              <Link to="/services/website-development" style={{ textDecoration: 'none' }}>
                <div className="service-slider-card">
                  <div className="service-card-image">
                    <img
                      src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80"
                      alt="Website Development"
                    />
                    <div className="service-card-overlay"></div>
                  </div>
                  <div className="service-card-content">
                    <div className="service-icon-wrapper">
                      <img src={require('../assets/images/services/ai-ml.png')} alt="icon" />
                    </div>
                    <h3 className="service-card-title">Website Development</h3>
                    <p className="service-card-subtitle">Elevate Your Digital Presence</p>
                    <p className="service-card-description">
                      Transform your brand with cutting-edge web design that combines stunning aesthetics with powerful functionality and delivers exceptional user experiences.
                    </p>
                  </div>
                </div>
              </Link>
            </SwiperSlide>

            {/* Service 3 - Software Development */}
            <SwiperSlide>
              <Link to="/services/software-development" style={{ textDecoration: 'none' }}>
                <div className="service-slider-card">
                  <div className="service-card-image">
                    <img
                      src="https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800&q=80"
                      alt="Software Development"
                    />
                    <div className="service-card-overlay"></div>
                  </div>
                  <div className="service-card-content">
                    <div className="service-icon-wrapper">
                      <img src={require('../assets/images/services/chip.png')} alt="icon" />
                    </div>
                    <h3 className="service-card-title">Software Development</h3>
                    <p className="service-card-subtitle">Transform Your Business</p>
                    <p className="service-card-description">
                      Partner with expert software engineers to create scalable, robust, and innovative software solutions. From enterprise applications to SaaS platforms, we bring your vision to life.
                    </p>
                  </div>
                </div>
              </Link>
            </SwiperSlide>

            {/* Service 4 - Digital Marketing */}
            <SwiperSlide>
              <Link to="/services/digital-marketing" style={{ textDecoration: 'none' }}>
                <div className="service-slider-card">
                  <div className="service-card-image">
                    <img
                      src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
                      alt="Digital Marketing"
                    />
                    <div className="service-card-overlay"></div>
                  </div>
                  <div className="service-card-content">
                    <div className="service-icon-wrapper">
                      <img src={require('../assets/images/services/blockchain.png')} alt="icon" />
                    </div>
                    <h3 className="service-card-title">Digital Marketing</h3>
                    <p className="service-card-subtitle">Accelerate Your Growth</p>
                    <p className="service-card-description">
                      Drive measurable results with data-driven marketing strategies that amplify your brand, engage your audience, and boost your ROI across all digital channels.
                    </p>
                  </div>
                </div>
              </Link>
            </SwiperSlide>

            {/* Service 5 - IT Consulting */}
            <SwiperSlide>
              <Link to="/services/it-consulting" style={{ textDecoration: 'none' }}>
                <div className="service-slider-card">
                  <div className="service-card-image">
                    <img
                      src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80"
                      alt="IT Consulting"
                    />
                    <div className="service-card-overlay"></div>
                  </div>
                  <div className="service-card-content">
                    <div className="service-icon-wrapper">
                      <img src={require('../assets/images/services/consultant.png')} alt="icon" />
                    </div>
                    <h3 className="service-card-title">IT Consulting</h3>
                    <p className="service-card-subtitle">Strategic Technology Advisory</p>
                    <p className="service-card-description">
                      Empower your organization with expert technology guidance that drives innovation, optimizes operations, and ensures sustainable growth with digital transformation.
                    </p>
                  </div>
                </div>
              </Link>
            </SwiperSlide>

            {/* Service 6 - Startup Consulting */}
            <SwiperSlide>
              <Link to="/services/startup-consulting" style={{ textDecoration: 'none' }}>
                <div className="service-slider-card">
                  <div className="service-card-image">
                    <img
                      src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&q=80"
                      alt="Startup Consulting"
                    />
                    <div className="service-card-overlay"></div>
                  </div>
                  <div className="service-card-content">
                    <div className="service-icon-wrapper">
                      <img src={require('../assets/images/services/mvp.png')} alt="icon" />
                    </div>
                    <h3 className="service-card-title">Startup Consulting</h3>
                    <p className="service-card-subtitle">Launch & Scale Your Startup</p>
                    <p className="service-card-description">
                      Transform your vision into reality with comprehensive startup consulting covering everything from MVP development to market launch and scaling strategies.
                    </p>
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          </Swiper>

          {/* View All Services Button */}
          <div className="text-center mt-5">
            <Link to="/services" style={{ textDecoration: 'none' }}>
              <div className="btn-view-all-services">
                <span>VIEW ALL SERVICES</span>
                <span className="btn-arrow">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Why Us Better Section */}
      {/* <section className="why-us-better-section py-5">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <div className="why-us-image-wrapper">
                <img
                  src="https://leadpanther.com/assets/images/about/about_image_5.webp"
                  alt="Why Us Better"
                  className="why-us-main-image"
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="why-us-content">
                <div className="section-label mb-3">
                  <span className="label-badge">Why Us</span>
                  <span className="label-text ms-2">Better</span>
                </div>

                <h2 className="why-us-title mb-4">
                  Why Our Services are<br />
                  Better Than Others?
                </h2>

                <div className="why-us-features">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="feature-box">
                        <div className="feature-icon">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                        <h4 className="feature-title">Quality Comes First</h4>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="feature-box">
                        <div className="feature-icon">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                        <h4 className="feature-title">Flexible Cooperation</h4>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="feature-box">
                        <div className="feature-icon">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 7L12 3L4 7M20 7L12 11M20 7V17L12 21M12 11L4 7M12 11V21M4 7V17L12 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                        <h4 className="feature-title">On-time Delivery</h4>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="feature-box">
                        <div className="feature-icon">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 7H6C4.89543 7 4 7.89543 4 9V18C4 19.1046 4.89543 20 6 20H15C16.1046 20 17 19.1046 17 18V15M9 7L11 9M9 7V4M15 5H20M20 5V10M20 5L11 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                        <h4 className="feature-title">Transparent Costs</h4>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="feature-box">
                        <div className="feature-icon">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.75 17L9 20L12 18L15 20L14.25 17M3 13H21M5 17H19C20.1046 17 21 16.1046 21 15V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V15C3 16.1046 3.89543 17 5 17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                        <h4 className="feature-title">Qualified Developers</h4>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="feature-box">
                        <div className="feature-icon">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 10V3L4 14H11V21L20 10H13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                        <h4 className="feature-title">Quick Scale-up</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="testimonial-section">
        <div className="container testimonial-container">
          <h2 className="testimonial-heading">
            Stories of Successful Digital <br />
            Transformation Served!
          </h2>

          <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={30}
            slidesPerView={1}
            breakpoints={{
              768: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
              1500: { slidesPerView: 4 },
            }}
            className="testimonial-swiper"
          >

            <SwiperSlide>
              <div className="testimonial-card">
                <div className="testimonial-stars">
                  ★★★★★
                </div>
                <p className="testimonial-text">
                  We have collaborated with Profit Technologies on multiple project requirements, and the overall experience has been consistently impressive. Their commitment, clarity in execution, and timely delivery make them a highly reliable technology partner organisation.
                </p>

                <div className="testimonial-user">
                  <div className="testimonial-avatar">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLgZuq2_ovZKkDelOPKIrIa7acQFjLj8NITQ&s" alt="Neil Patwardhan" />
                  </div>
                  <div>
                    <div className="testimonial-name">Neil Patwardhan</div>
                    <div className="testimonial-role">Vmware</div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            {/* Slide 3 */}
            <SwiperSlide>
              <div className="testimonial-card">
                <div className="testimonial-stars">
                  ★★★★☆
                </div>
                <p className="testimonial-text">
                  We required an intelligent chatbot and personalization engine for our store, and they delivered far beyond expectations. Our conversions improved noticeably, support load reduced significantly, and their team proved to be an exceptional and dependable AI partner.
                </p>

                <div className="testimonial-user">
                  <div className="testimonial-avatar">
                    <img src="https://i.pinimg.com/736x/b2/e1/af/b2e1af76fbbe9bc446544b8fa71b37b1.jpg" alt="Neil Patwardhan" />
                  </div>
                  <div>
                    <div className="testimonial-name">Vivek Sinha</div>
                    <div className="testimonial-role">PhonePe</div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            {/* Slide 4 */}
            <SwiperSlide>
              <div className="testimonial-card">
                <div className="testimonial-stars">
                  ★★★★★
                </div>
                <p className="testimonial-text">
                  We shared only a raw idea with them, and within weeks they built an AI-powered prototype that impressed our investors. Their team understands startup urgency, moves fast, and consistently delivers high-quality work with clear communication.
                </p>

                <div className="testimonial-user">
                  <div className="testimonial-avatar">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQdn5x1THeZbhPoI8VmmFYiczhtO5H1cPtgGA&s" alt="ElsaMarie D'Silva" />
                  </div>
                  <div>
                    <div className="testimonial-name">Ankit Kumar</div>
                    <div className="testimonial-role">
                      Tyroo
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial-card">
                <div className="testimonial-stars">
                  ★★★★★
                </div>
                <p className="testimonial-text">
                  I’ve collaborated with many AI vendors, but this team stands out for their speed, clarity, and strong technical expertise. They built a tailored machine-learning solution that streamlined our processes and delivered nearly a 30% improvement in overall efficiency.
                </p>

                <div className="testimonial-user">
                  <div className="testimonial-avatar">
                    <img src="https://play-lh.googleusercontent.com/ANBO3wrnXPfQctNXOiPCJMRhKRkbC7OZz6dIhEFNu7HaBdOdG7eLSVJvN_EuImlCl9g" alt="ElsaMarie D'Silva" />
                  </div>
                  <div>
                    <div className="testimonial-name">Jaisa James</div>
                    <div className="testimonial-role">
                      Abbott
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial-card">
                <div className="testimonial-stars">
                  ★★★★★
                </div>
                <p className="testimonial-text">
                  We have collaborated with Profit Technologies on multiple project requirements, and the overall experience has been consistently impressive. Their commitment, clarity in execution, and timely delivery make them a highly reliable technology partner organisation.
                </p>

                <div className="testimonial-user">
                  <div className="testimonial-avatar">
                    <img src="https://media.licdn.com/dms/image/v2/D4E0BAQGHfr399QvNWQ/company-logo_200_200/company-logo_200_200/0/1704118457246/monogram_health_logo?e=2147483647&v=beta&t=mcHUPTV6IEL6JVZaYTz6AI3WnCUfd0DKcZLd0O0ZzVs" alt="Ashneer Grover" />
                  </div>
                  <div>
                    <div className="testimonial-name">Mitesh Sinha</div>
                    <div className="testimonial-role">Monogram Health</div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            {/* Slide 3 */}
            <SwiperSlide>
              <div className="testimonial-card">
                <div className="testimonial-stars">
                  ★★★★★
                </div>
                <p className="testimonial-text">
                  We have collaborated with Profit Technologies on multiple project requirements, and the overall experience has been consistently impressive. Their commitment, clarity in execution, and timely delivery make them a highly reliable technology partner organisation.
                </p>

                <div className="testimonial-user">
                  <div className="testimonial-avatar">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLgZuq2_ovZKkDelOPKIrIa7acQFjLj8NITQ&s" alt="Neil Patwardhan" />
                  </div>
                  <div>
                    <div className="testimonial-name">Neil Patwardhan</div>
                    <div className="testimonial-role">Vmware</div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            {/* Slide 3 */}
            <SwiperSlide>
              <div className="testimonial-card">
                <div className="testimonial-stars">
                  ★★★★☆
                </div>
                <p className="testimonial-text">
                  We required an intelligent chatbot and personalization engine for our store, and they delivered far beyond expectations. Our conversions improved noticeably, support load reduced significantly, and their team proved to be an exceptional and dependable AI partner.
                </p>

                <div className="testimonial-user">
                  <div className="testimonial-avatar">
                    <img src="https://i.pinimg.com/736x/b2/e1/af/b2e1af76fbbe9bc446544b8fa71b37b1.jpg" alt="Neil Patwardhan" />
                  </div>
                  <div>
                    <div className="testimonial-name">Vivek Sinha</div>
                    <div className="testimonial-role">PhonePe</div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            {/* Slide 4 */}
            <SwiperSlide>
              <div className="testimonial-card">
                <div className="testimonial-stars">
                  ★★★★★
                </div>
                <p className="testimonial-text">
                  We shared only a raw idea with them, and within weeks they built an AI-powered prototype that impressed our investors. Their team understands startup urgency, moves fast, and consistently delivers high-quality work with clear communication.
                </p>

                <div className="testimonial-user">
                  <div className="testimonial-avatar">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQdn5x1THeZbhPoI8VmmFYiczhtO5H1cPtgGA&s" alt="ElsaMarie D'Silva" />
                  </div>
                  <div>
                    <div className="testimonial-name">Ankit Kumar</div>
                    <div className="testimonial-role">
                      Tyroo
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial-card">
                <div className="testimonial-stars">
                  ★★★★★
                </div>
                <p className="testimonial-text">
                  I’ve collaborated with many AI vendors, but this team stands out for their speed, clarity, and strong technical expertise. They built a tailored machine-learning solution that streamlined our processes and delivered nearly a 30% improvement in overall efficiency.
                </p>

                <div className="testimonial-user">
                  <div className="testimonial-avatar">
                    <img src="https://play-lh.googleusercontent.com/ANBO3wrnXPfQctNXOiPCJMRhKRkbC7OZz6dIhEFNu7HaBdOdG7eLSVJvN_EuImlCl9g" alt="ElsaMarie D'Silva" />
                  </div>
                  <div>
                    <div className="testimonial-name">Jaisa James</div>
                    <div className="testimonial-role">
                      Abbott
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial-card">
                <div className="testimonial-stars">
                  ★★★★★
                </div>
                <p className="testimonial-text">
                  We have collaborated with Profit Technologies on multiple project requirements, and the overall experience has been consistently impressive. Their commitment, clarity in execution, and timely delivery make them a highly reliable technology partner organisation.
                </p>

                <div className="testimonial-user">
                  <div className="testimonial-avatar">
                    <img src="https://media.licdn.com/dms/image/v2/D4E0BAQGHfr399QvNWQ/company-logo_200_200/company-logo_200_200/0/1704118457246/monogram_health_logo?e=2147483647&v=beta&t=mcHUPTV6IEL6JVZaYTz6AI3WnCUfd0DKcZLd0O0ZzVs" alt="Ashneer Grover" />
                  </div>
                  <div>
                    <div className="testimonial-name">Mitesh Sinha</div>
                    <div className="testimonial-role">Monogram Health</div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>

      {/* Our Trusted Clients Section */}
      <section className="trusted-clients-section py-5">
        <div className="container">
          <div className="text-center mb-5">
            <span className="services-label">OUR PARTNERS</span>
            <h2 className="services-main-heading">
              Our Trusted <span className="text-gradient">Clients</span>
            </h2>
            <p className="services-subtitle">
              Partnering with industry leaders and innovative businesses worldwide
            </p>
          </div>

          <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            slidesPerView={2}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            speed={1000}
            loop={true}
            breakpoints={{
              576: {
                slidesPerView: 3,
                spaceBetween: 30
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 30
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 30
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 30
              }
            }}
            className="clients-logo-swiper"
          >
            <SwiperSlide>
              <div className="client-logo-wrapper">
                <img
                  src={require('../assets/images/client/clint-1.webp')}
                  alt="Client 1"
                  className="client-logo"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="client-logo-wrapper">
                <img
                  src={require('../assets/images/client/clint-2.png')}
                  alt="Client 2"
                  className="client-logo"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="client-logo-wrapper">
                <img
                  src={require('../assets/images/client/clint-3.png')}
                  alt="Client 3"
                  className="client-logo"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="client-logo-wrapper">
                <img
                  src={require('../assets/images/client/clint-4.png')}
                  alt="Client 4"
                  className="client-logo"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="client-logo-wrapper">
                <img
                  src={require('../assets/images/client/clint-5.png')}
                  alt="Client 5"
                  className="client-logo"
                />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>

      {/* Blog Section */}
      <section className="blog-section py-5">
        <div className="container">
          <div className="text-center mb-5">
            <span className="services-label">INSIGHTS & TRENDS</span>
            <h2 className="services-main-heading">
              Latest From Our <span className="text-gradient">Blog</span>
            </h2>
            <p className="services-subtitle">
              Stay updated with the latest technology trends, insights, and best practices
            </p>
          </div>

          <div className="row g-4">
            {/* Blog 1 - Website Development */}
            <div className="col-lg-4 col-md-6">
              <Link to="/blog/website-development" style={{ textDecoration: 'none' }}>
                <div className="blog-card">
                  <div className="blog-card-image">
                    <img
                      src="https://images.unsplash.com/photo-1547658719-da2b51169166?w=800&q=80"
                      alt="Website Development"
                    />
                    <div className="blog-card-overlay"></div>
                    <div className="blog-category-badge">Website Development</div>
                  </div>
                  <div className="blog-card-content">
                    <div className="blog-card-meta">
                      <span className="blog-date">
                        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 2V6M14 2V6M3 10H17M5 4H15C16.1046 4 17 4.89543 17 6V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V6C3 4.89543 3.89543 4 5 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        December 1, 2024
                      </span>
                    </div>
                    <h3 className="blog-card-title">
                      Building Modern Websites: A Complete Guide to Website Development in 2024
                    </h3>
                    <p className="blog-card-excerpt">
                      Discover how professional website development can transform your online presence and drive business growth in today's digital landscape.
                    </p>
                    <div className="blog-read-more">
                      Read More
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            {/* Blog 2 - Digital Marketing */}
            <div className="col-lg-4 col-md-6">
              <Link to="/blog/digital-marketing" style={{ textDecoration: 'none' }}>
                <div className="blog-card">
                  <div className="blog-card-image">
                    <img
                      src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
                      alt="Digital Marketing"
                    />
                    <div className="blog-card-overlay"></div>
                    <div className="blog-category-badge">Digital Marketing</div>
                  </div>
                  <div className="blog-card-content">
                    <div className="blog-card-meta">
                      <span className="blog-date">
                        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 2V6M14 2V6M3 10H17M5 4H15C16.1046 4 17 4.89543 17 6V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V6C3 4.89543 3.89543 4 5 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        December 15, 2024
                      </span>
                    </div>
                    <h3 className="blog-card-title">
                      Digital Marketing Strategies That Drive Real Business Results in 2024
                    </h3>
                    <p className="blog-card-excerpt">
                      Learn how to leverage powerful digital marketing strategies to increase brand visibility, generate leads, and accelerate growth.
                    </p>
                    <div className="blog-read-more">
                      Read More
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            {/* Blog 3 - IT Consulting */}
            <div className="col-lg-4 col-md-6">
              <Link to="/blog/it-consulting" style={{ textDecoration: 'none' }}>
                <div className="blog-card">
                  <div className="blog-card-image">
                    <img
                      src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80"
                      alt="IT Consulting"
                    />
                    <div className="blog-card-overlay"></div>
                    <div className="blog-category-badge">IT Consulting</div>
                  </div>
                  <div className="blog-card-content">
                    <div className="blog-card-meta">
                      <span className="blog-date">
                        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 2V6M14 2V6M3 10H17M5 4H15C16.1046 4 17 4.89543 17 6V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V6C3 4.89543 3.89543 4 5 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        December 19, 2024
                      </span>
                    </div>
                    <h3 className="blog-card-title">
                      IT Consulting: Strategic Technology Solutions for Business Transformation
                    </h3>
                    <p className="blog-card-excerpt">
                      Explore how expert IT consulting can help your business leverage technology for competitive advantage and sustainable growth.
                    </p>
                    <div className="blog-read-more">
                      Read More
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default Home;
